import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { TeamDto, TeamsResponseModel } from "@gtpl/shared-models/hrms";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { TeamRequest } from "./dtos/teams.request";
import { TeamsEntity } from "./entities/teams.entity";
import { TeamsAdapter } from "./teams.adapter";
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import { UserRequestDto } from "./dtos/user-request-dto";

export class TeamsService {
    constructor(
      private logService:LogsService,
        @InjectRepository(TeamsEntity)
        private repo: Repository<TeamsEntity>,
        private adapter: TeamsAdapter,
    ) { }

    async getTeamsDetails(shiftCode: string): Promise<TeamsEntity> {
        const teamResponse = await this.repo.findOne({
            where: { shiftCode: shiftCode },
        });
        if (teamResponse) {
            return teamResponse;
        } else {
            return null;
        }
    }

    async createTeam(dto: TeamDto, isUpdate: boolean): Promise<TeamsResponseModel> {
        try {
            if (!isUpdate) {
                const entity = await this.getTeamsDetails(dto.shiftCode);
                if (entity) {
                    throw new ErrorResponse(11104, 'Shift Group already exists');
                }
            } else {
                const entity = await this.getTeamsDetails(dto.shiftCode);
                if (entity) {
                    if (entity.id != dto.id) {
                        throw new ErrorResponse(11104, 'Shift Group already exists')
                    }
                }
            }
            const convertedEntity: TeamsEntity = this.adapter.convertDtoToEntity(dto, isUpdate);
            const savedEntity: TeamsEntity = await this.repo.save(convertedEntity);
            const savedDto: TeamDto = this.adapter.convertEntityToDto(savedEntity);
            if (savedDto) {
                const response = new TeamsResponseModel(true, 1, isUpdate ? 'Team Updated Successfully' : 'Team Created Successfully');
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Country Updated Successfully': 'Country Created Successfully'
            const userName = isUpdate? savedDto.updatedUser :savedDto.createdUser;
                const newLogDto = new LogsDto(1,name, 'TeamsEntity', savedDto.id, true, displayValue,'','',userName)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Team saved but issue while transforming it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }


    async getAllTeams(req?:UserRequestDto): Promise<TeamsResponseModel> {
        try {
            const temDto: TeamDto[] = [];
            const temEntity: TeamsEntity[] = await this.repo.find({ order: { id: 'DESC' } });
            if (temEntity.length) {
                temEntity.forEach(Entity => {
                    const convertedDto: TeamsEntity = this.adapter.convertEntityToDto(Entity);
                    temDto.push(convertedDto);
                });
                const response = new TeamsResponseModel(true, 1, 'Team Retrieved Successfully', temDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'TeamsEntity', 0, true, 'Team Retrieved Successfully','','',req.createdUser)
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
               
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveTeams(): Promise<TeamsResponseModel> {
        try {
            const temDto: TeamDto[] = [];
            const temEntity: TeamsEntity[] = await this.repo.find({ order: { id: 'ASC' }, where: { isActive: true }, });
            if (temEntity) {
                temEntity.forEach(Entity => {
                    const convertedEntity: TeamDto = this.adapter.convertEntityToDto(Entity);
                    temDto.push(convertedEntity);
                });
                const response = new TeamsResponseModel(true, 11108, 'Active Team Retrieved Successfully', temDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getTeamById(id: number): Promise<TeamsEntity> {
        const response = await this.repo.findOne({
            where: { id: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateTeams(temReq: TeamRequest): Promise<TeamsResponseModel> {
        try {
            const temExists = await this.getTeamById(temReq.id);
            if (temExists) {
                if (temReq.versionFlag != temExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Team information. Refresh and try again');
                } else {
                    const temStatus = await this.repo.update(
                        { id: temReq.id },
                        { isActive: temReq.isActive, updatedUser: temReq.updatedUser }
                    );
                    if (temExists.isActive) {
                        if (temStatus.affected) {
                            const temResponse: TeamsResponseModel = new TeamsResponseModel(true, 10115, 'Team is de-activated successfully');
                            return temResponse;
                        } else {
                            throw new ErrorResponse(10111, ' Team is already de-activated');
                        }
                    } else {
                        if (temStatus.affected) {
                            const temResponse: TeamsResponseModel = new TeamsResponseModel(true, 10114, 'Team is activated successfully');
                            return temResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Teams is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

}